import WithdrawModal from "./withdraw-modal.component";

export default WithdrawModal;
